export default "assets/images/logo-secondary-8963ad60.png";